// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"p3","lowTopMargin":"p4","rightColumnWrapper":"p5","rightColumnTitle":"p6","title":"p7"};